import * as firebase from 'firebase';

const config = {
  apiKey: "AIzaSyDsoqy00vh0Pj_5gX0BW7zA4m3qiaJbjyg",
  authDomain: "bioenergy-2a67e.firebaseapp.com",
  databaseURL: "https://", //https://bioenergy-2a67e.firebaseio.com
  projectId: "bioenergy-2a67e",
  storageBucket: "bioenergy-2a67e.appspot.com",
  messagingSenderId: "238261911373",
  appId: "1:238261911373:web:2ec2fc05f69e9e700d4104",
  measurementId: "G-WFWV7HDGE8"
};

const firebaseApp = firebase.initializeApp(config);

export const db = firebaseApp.firestore();